<template>
  <div class="simple-add">
    <div class="simple-list">
      <div class="ans-count">共提交 {{ answerCount }} 人</div>
      <div class="titles" v-for="title in titles" :key="title.eventExamTitleId">
        <div class="option-item" v-for="(option, index) in title.options" :key="index">
          <div class="num">{{ option.name }}</div>
          <div class="progress">
            <div :style="{width: `${Number(option.accounted)}%`}" class="progress-content"></div>
          </div>
          <div class="percentage">{{ Number(option.accounted) }}%</div>
          <div @click="handle2DetailPerson(title.eventExamTitleId, option.eventExamOptionsId, 1)" class="answer-num">
            {{ option.answerCounts }}人
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div @click="stopAnswer" v-if="status == 1 && paperId" class="btn">停止答题</div>
      <div @click="handle2AddSimple" v-if="status == 2 && paperId" class="btn btn1">继续发题</div>
    </div>
  </div>
</template>

<script>
import {getsimpletotal, simpleStop} from '@/api'
// eslint-disable-next-line no-unused-vars
import {wsMixin} from '@/views/activePlay/wsMixin.js'
export default {
  mixins: [wsMixin],
  data() {
    return {
      id: this.$route.params.id,
      paperId: this.$route.query.paperId,
      status: this.$route.query.status, // 1 正在答 2 已答完
      answerCount: 0,
      titles: []
    }
  },
  created() {
    this.initSimpleTotal()
  },
  // computed: {
  //   ws() {
  //     return this.$store.state.activePlay.ws
  //   }
  // },
  methods: {
    async initSimpleTotal() {
      const params = {
        eventId: this.id,
        paperId: this.paperId
      }
      const result = await getsimpletotal(params)
      if (result.code === 0) {
        this.answerCount = result.data.answerCounts
        this.titles = result.data.titles
      }
    },
    handle2DetailPerson(titleId, optionId, type) {
      this.$router.push(`/activeAnsDetailPerson/${this.id}?titleId=${titleId}&optionId=${optionId}&type=${type}`)
    },
    handle2AddSimple() {
      this.$router.push(`/activeSimpleAdd/${this.id}?paperId=${this.paperId}`)
    },
    async stopAnswer() {
      if (!this.wsOpen) {
        return this.$Toast.success('停止失败，请重试')
      }
      const params = {
        eventId: this.id,
        paperId: this.paperId
      }
      const result = await simpleStop(params)
      if (result.code === 0) {
        const obj = {
          c: 30001,
          a: {
            isCheckbox: '', // isCheckbox: 1. 单选 2. 多选
            objectId: this.paperId, // 答题卡id
            objectType: 2, // type 1. 标准出题  2. 快速出题
            stop: 1 // 停止答题
          },
          e: this.id
        }
        this.ws.send(JSON.stringify(obj))
        this.$Toast.success('停止成功')
        setTimeout(() => {
          this.$router.replace(`/activeQueList/${this.id}`)
        }, 2000)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.simple-add {
  height: 100vh;
  padding: 10px 10px 70px;
}

.simple-list {
  .ans-count {
    color: #909399;
    margin-bottom: 20px;
  }

  .titles {
    margin-top: 20px;
  }
  .option-item + .option-item {
    margin-top: 20px;
  }
  .option-item {
    display: flex;
    align-items: center;
    .num {
      width: 28px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      background: #eef0f3;
      color: #333333;
      margin-right: 10px;
    }
    .progress {
      flex: 1;
      background: #f1f3f6;
      border-radius: 10px;
      position: relative;
      height: 10px;
      div {
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 10px;
        border-radius: 10px;
        background: rgba(9, 165, 46, 1);
      }
    }
    .percentage {
      text-align: center;
      color: #909399;
      width: 60px;
    }
    .answer-num {
      text-align: center;
      color: #4465f3;
      width: 60px;
    }
  }
}

.bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 70px;
  padding: 0 10px;
  box-shadow: 0px -3px 8px 0px rgba(0, 0, 0, 0.04);
  background: #fff;
  line-height: 70px;
  .btn {
    width: 100%;
    height: 50px;
    display: inline-block;
    border-radius: 47px;
    background: linear-gradient(90deg, #fda423, #f39e23);
    text-align: center;
    line-height: 50px;
    color: #fff;
  }
  .btn1 {
    background: linear-gradient(90deg, #4a86f6, #4465f3);
  }
}
</style>
